import React, { useState } from "react";
import Button from "../form/Button";
import Quiltext from "../elements/Quiltext";
import dayjs from "dayjs";
import Modal from "../elements/Modal";
import EligibilityQuizContent from "./EligibilityQuizContent";

const ApplicationDetails = ({
  data = {},
  onApply = () => {},
  close = () => {},
}) => {
  console.log({ data });

  return (
    <>
      <div className="divide-y divide-slate-300">
        {/* <div className="space-y-4 py-8">
          <h2 className="text-xl tracking-tight font-semibold text-center text-chestnut-rose">
            Overview
          </h2>
          <div className="space-y-3 font-Gotham font-medium text-center max-w-4xl mx-auto">
            <p>
              The Disabled for Education Scholarship is designed to support
              students with disabilities who face financial and accessibility
              challenges in their academic journey. This scholarship aims to
              empower and encourage students by providing financial assistance
              to help them achieve their educational goals.
            </p>
          </div>
        </div> */}
        <div className="py-4 flex flex-col md:flex-row items-center justify-between gap-1">
          <div className="flex items-center gap-2 text-sm md:text-lg">
            <span className="text-chestnut-rose font-medium">
              {data?.scholarshipTitle} :
            </span>
            <span className="font-medium">
              {data?.scholarshipAmount ? data?.scholarshipAmount : "N/A"}
            </span>
          </div>
          <div className="flex items-center gap-2 text-sm md:text-lg">
            <span className="text-chestnut-rose font-medium">
              {data?.recipientTitle} :
            </span>
            <span className="font-medium">
              {data?.maxNumberOfApply ? data?.maxNumberOfApply : "N/A"}
            </span>
          </div>
        </div>
        <div className="space-y-4 py-8">
          <h2 className="text-xl tracking-tight font-semibold text-center text-chestnut-rose">
            Overview
          </h2>
          <div className="space-y-3 font-Gotham font-medium max-w-4xl mx-auto application application-requirement">
            {data?.requirement && (
              <Quiltext description={data?.requirement || ""} />
            )}
            {/* <ul>
              <li>Must have a documented disability</li>
              <li>
                Currently enrolled or accepted into a recognized educational
                institution
              </li>
              <li>Demonstrate financial need</li>
              <li>
                Submit a personal statement explaining educational goals and
                challenges faced
              </li>
            </ul> */}
          </div>
        </div>
        <div className="space-y-4 py-8">
          <h2 className="text-xl tracking-tight font-semibold text-center text-chestnut-rose">
            Application Requirements
          </h2>
          <div className="space-y-3 font-Gotham font-medium max-w-4xl mx-auto application application-instruction">
            {/* <ul>
              <li>Completed application form</li>
              <li>
                Proof of disability (doctor’s note or official documentation)
              </li>
              <li>Academic transcript or acceptance letter</li>
              <li>
                500-word personal statement detailing your educational journey
                and aspirations
              </li>
            </ul> */}

            {data?.applicationInstruction && (
              <Quiltext description={data?.applicationInstruction || ""} />
            )}
          </div>
        </div>
        <div className="space-y-4 py-8">
          <h2 className="text-xl tracking-tight font-semibold text-center text-chestnut-rose">
            Deadline
          </h2>
          <div className="space-y-3 font-Gotham font-medium max-w-4xl mx-auto">
            <ul>
              <li>
                Opens:{" "}
                {data?.publishDate &&
                  dayjs(data?.publishDate).format("MMMM DD, YYYY")}
              </li>
              <li>
                Closed:{" "}
                {data?.publishEndDate
                  ? dayjs(data?.publishEndDate).format("MMMM DD, YYYY")
                  : "Ongoing"}
              </li>
            </ul>
          </div>
        </div>
        <div className="space-y-4 py-8">
          <div className="flex justify-center gap-4">
            <Button
              buttonLabel={"Close"}
              buttonFunction={() => {
                close();
              }}
              buttonClasses="!h-12 xl:!h-12 !rounded-full !px-8 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="!text-base xl:!text-xl"
            />
            <Button
              buttonLabel={"Apply"}
              buttonFunction={() => {
                onApply(data);
              }}
              buttonClasses="!h-12 xl:!h-12 !rounded-full !px-8 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="!text-base xl:!text-xl"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplicationDetails;
